export default {
    namespaced: true,
    pbx_call: {
      title: "Llamada | Llamadas",
      uuid: "UUID",
      status: "Estatus",
      caller: "llamante",
      receiver: "receptor",
      started_at: "empezó a",
      ended_at: "terminó a",
      recording: "grabación",
    },
  };
  